import React from 'react';
import _ from 'lodash';
import { Input, Button, Tag } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import styles from './CustomFieldNodeContent.module.scss';
import message from '../../../Containers/Connect/ConnectMessages';

 function CustomFieldNodeContent(props) {
  const { initialValue, form, drawerFooter, intl } = props;
  const initialCustomFields = _.get(initialValue, 'CustomFields', []);
  const [nameInput, setNameInput] = React.useState('');
  const [valueInput, setValueInput] = React.useState('');

  form.getFieldDecorator('CustomFields', { initialValue: initialCustomFields });
  const { CustomFields: customFieldPairs } = form.getFieldsValue();

  const onAddFieldValue = () => {
    const fieldAlreadyExists = customFieldPairs.find(item => item.Name === nameInput && item.Value === valueInput);
    if (!fieldAlreadyExists) {
      form.setFieldsValue({
        CustomFields: [...customFieldPairs, { Name: nameInput, Value: valueInput }],
      });
    }
    setNameInput('');
    setValueInput('');
  };

  const onRemoveField = field => {
    form.setFieldsValue({
      CustomFields: customFieldPairs.filter(item => item !== field),
    });
  };

  const isAddFieldDisabled = !(nameInput && valueInput);

  return (
    <div className={styles.customFieldContainer}>
      <div className={styles.inputSection}>
        <Input onChange={e => setNameInput(e.target.value)} value={nameInput} placeholder={intl.formatMessage({ ...message.enterAName })} />
        <Input onChange={e => setValueInput(e.target.value)} value={valueInput} placeholder={intl.formatMessage({ ...message.enterAValueLabel })} />
      </div>
      <Button type="link" onClick={onAddFieldValue} disabled={isAddFieldDisabled}>
        <span> <FormattedMessage {...message.addAnotherFieldLabel} /></span>
      </Button>
      <div className={styles.tagList}>
        {customFieldPairs.map(field => (
          <Tag closable key={field} value={field} onClose={() => onRemoveField(field)}>
            {`"${field.Name} = ${field.Value}"`}
          </Tag>
        ))}
      </div>
      <div className={styles.customTagDrawerFooter}>{drawerFooter}</div>
    </div>
  );
}

export default injectIntl(CustomFieldNodeContent);
export { CustomFieldNodeContent as CustomFieldNodeContentWithoutInjectIntl };
